import React from 'react';
import { LikeServices } from './Services';

const loadedData: any = {
    nftLikes: [],
    collectionLikes: [],
}

const loadNFTLikeCounts = (nfts: { collectionAddress: string, tokenID: number }[]) => {
    //filter out nfts that are already in loaded array
    const nftsToLoad = nfts.filter(nft => !loadedData.nftLikes.some((loadedNFT: any) => loadedNFT.collectionAddress.toLowerCase() === nft.collectionAddress.toLowerCase() && loadedNFT.tokenID == nft.tokenID));
    if (nftsToLoad.length > 0) {
        LikeServices.GetNFTLikeCounts(nftsToLoad.map(n => ({ collectionAddress: n.collectionAddress.toLowerCase(), tokenID: n.tokenID.toString() }))).then((res: any) => {
            loadedData.nftLikes = [...loadedData.nftLikes, ...res];
        })
    }
}

const loadCollectionLikeCounts = (collections: { collectionAddress: string }[]) => {
    //filter out collections that are already in loaded array
    const collectionsToLoad = collections.filter(collection => !loadedData.collectionLikes.some((loadedCollection: any) => loadedCollection.collectionAddress.toLowerCase() === collection.collectionAddress.toLowerCase()));
    if (collectionsToLoad.length > 0) {
        LikeServices.GetCollectionLikeCounts(collectionsToLoad.map(n => ({ collectionAddress: n.collectionAddress.toLowerCase() }))).then((res: any) => {
            loadedData.collectionLikes = [...loadedData.collectionLikes, ...res];
        })
    }
}

const useCollectionLikeCount = (contractAddress: string) => {
    const [likeCount, setLikeCount] = React.useState(0);

    React.useEffect(() => {
        if (!contractAddress) return;
        let collectionIndex = loadedData.collectionLikes.findIndex((loadedCollection: any) => loadedCollection.collectionAddress.toLowerCase() === contractAddress.toLowerCase());
        if (collectionIndex > -1) {
            const loadedCollection = loadedData.collectionLikes.find((loadedCollection: any) => loadedCollection.collectionAddress.toLowerCase() === contractAddress.toLowerCase());
            setLikeCount(loadedCollection.likes);
        }
    }, [contractAddress, loadedData.collectionLikes]);

    const addToLiked = React.useCallback((contractAddress: string) => {
        let collectionIndex = loadedData.collectionLikes.findIndex((loadedCollection: any) => loadedCollection.collectionAddress.toLowerCase() === contractAddress.toLowerCase());
        if (collectionIndex === -1) {
            setLikeCount(likeCount + 1);
            loadedData.collectionLikes.push({
                contractAddress: contractAddress,
                likes: likeCount + 1
            })
        } else {
            setLikeCount(likeCount + 1);
            loadedData.collectionLikes[collectionIndex].likes = likeCount + 1;
        }
    }, [likeCount, loadedData.collectionLikes]);


    const removeFromLiked = React.useCallback((contractAddress: string) => {
        let collectionIndex = loadedData.collectionLikes.findIndex((loadedCollection: any) => loadedCollection.collectionAddress.toLowerCase() === contractAddress.toLowerCase());
        if (collectionIndex !== -1) {
            setLikeCount(likeCount - 1);
            loadedData.collectionLikes[collectionIndex].likes = likeCount - 1;
        }
    }, [likeCount, loadedData.collectionLikes]);


    return { likeCount, addToLiked, removeFromLiked };
}

const useNFTLikeCount = (contractAddress: string, tokenID: number) => {
    const [count, setCount] = React.useState(0);

    React.useEffect(() => {
        if (!contractAddress || !tokenID) return;
        let nftLikeCount = loadedData.nftLikes.find((nftLike: any) => nftLike.collectionAddress.toLowerCase() === contractAddress.toLowerCase() && nftLike.tokenID.toString() === tokenID.toString());
        if (nftLikeCount) {
            setCount(nftLikeCount.likes);
        }
    }, [contractAddress, tokenID, loadedData.nftLikes]);

    const addToLiked = React.useCallback((contractAddress: string, tokenID: number) => {
        let nftIndex = loadedData.nftLikes.findIndex((nftLike: any) => nftLike.collectionAddress === contractAddress && nftLike.tokenID.toString() === tokenID.toString());
        if (nftIndex === -1) {
            loadedData.nftLikes.push({
                contractAddress: contractAddress,
                tokenID: tokenID.toString(),
                likes: 1
            });
            setCount(count + 1);
        } else {
            loadedData.nftLikes[nftIndex].likes++;
            setCount(count + 1);
        }
    }, [count, loadedData.nftLikes]);

    const removeFromLiked = React.useCallback((contractAddress: string, tokenID: number) => {
        let nftIndex = loadedData.nftLikes.findIndex((nftLike: any) => nftLike.collectionAddress === contractAddress && nftLike.tokenID.toString() === tokenID.toString());
        if (nftIndex !== -1) {
            loadedData.nftLikes[nftIndex].likes--;
            setCount(count - 1);
        }
    }, [count, loadedData.nftLikes]);

    return { count, addToLiked, removeFromLiked };
}

export {
    useNFTLikeCount,
    loadNFTLikeCounts,
    useCollectionLikeCount,
    loadCollectionLikeCounts
}